import { useGetOnHoldClaimRequest } from './useGetOnHoldClaimRequests';
import { UseAsyncStatus } from '../../../../domain/utils';
import { useHref } from '../../../hooks';
import { usePet } from '../../../../application/usePet';
import { BlockingLoader } from '../../../molecules';
import { ClaimRequestsList } from '../../../organisms';

const OnHoldListPage = () => {
    const { toDataEntry } = useHref();

    const { onHoldClaimRequest, onHoldClaimRequestFetchStatus } = useGetOnHoldClaimRequest();
    const { findPetByPolicyIdentifier } = usePet();
    return (
        <section className={'on-hold-list-page-container'}>
            {onHoldClaimRequestFetchStatus == UseAsyncStatus.SUCCESS ? (
                <ClaimRequestsList
                    claimRequests={onHoldClaimRequest!!}
                    goToDetail={toDataEntry}
                    getPetInformation={findPetByPolicyIdentifier!!}
                ></ClaimRequestsList>
            ) : (
                <BlockingLoader />
            )}
        </section>
    );
};
export { OnHoldListPage };
